<h2 [sxc-toolbar]="toolbarHelperSvc.toolbarMain(categoryInfo().EntityId)">Real-time target machines and Components</h2>

<span [innerHTML]="categoryInfo().NotesBefore"></span>

@for (component of sortedComponents(); track component.SN) {
  <mat-accordion>
    <mat-expansion-panel style="margin-bottom: 8px">
      <mat-expansion-panel-header>
        <mat-panel-title>
          @if (component.SN) {
            @if (component.Title) {
              <span> {{ component.Title }}, &nbsp; </span>
            }
            Serial number: {{ component.SN }}
          } @else {
            Components / Accessories
          }
        </mat-panel-title>
      </mat-expansion-panel-header>
      <table class="table table-hover table-stacked table-striped">
        <colgroup>
          <col style="width: 50%" />
          <col style="width: 50%" />
        </colgroup>
        <tbody>
          @for (group of groupFilesByProduct(component.Files); track group.product) {
            <tr>
              <!-- Left Side, System then all Product -->
              <td [sxc-toolbar]="toolbarHelperSvc.toolbarAddDownload()">
                @if (group.product) {
                  <span>{{ group.product }}</span>
                } @else if (component.SN) {
                  <span>System</span>
                }
              </td>
              <!-- Right Side, all Downloads for each Product -->
              <td>
                @for (dl of group.downloads; track dl.Id) {
                  <div [sxc-toolbar]="toolbarHelperSvc.toolbarEditDownload(dl.Id, dl.Title, dl.EntityGuid)">
                    <a [href]="dl.DownloadUrl ?? dl.File" [attr.target]="dl.Target" style="display: block">
                      {{ dl.Title }}
                    </a>
                  </div>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </mat-expansion-panel>
  </mat-accordion>
}

<span [innerHTML]="categoryInfo().NotesAfter"></span>

@if (components().length === 0) {
  No downloads available. There aren't real-time target machines linked to your account. If you do have a real-time target machine, please <a href="mailto:support@speedgoat.com">contact the Speedgoat Support team</a>. If you recently purchased a
  real-time target machine, downloads will be available at the time of delivery.
}
